<template>
    <div class="modal-fade app-vue" :class="{ 'is-active': active }">
        <div class="modal is-active" :class="classes">
            <div class="modal-background" @click="closeModal('background')" />
            <div
                v-if="(form && form.successful) || isSuccessful"
                class="modal-card"
                :class="cardClass"
                :style="cardStyles"
            >
                <section class="modal-card-body">
                    <modal-alert-success v-if="successHtml != null">
                        <div v-html="successHtml" />
                    </modal-alert-success>
                    <modal-alert-success v-else>
                        {{ successText }}
                    </modal-alert-success>
                </section>
            </div>
            <div v-else-if="showError" class="modal-card" :class="cardClass" :style="cardStyles">
                <section class="modal-card-body">
                    <modal-alert-error>
                        <span v-html="errorText" />
                    </modal-alert-error>
                </section>
            </div>
            <form
                v-else
                class="modal-card"
                :class="cardClass"
                :style="cardStyles"
                @submit.prevent="submit"
            >
                <header v-if="!hideHeader" class="modal-card-head">
                    <p class="modal-card-title">
                        <template v-if="titleChange">
                            <span class="modal-card-title--pointer" @click="titleChange">
                                <fa-icon v-if="titleIcon" :icon="titleIcon" />
                            </span>
                        </template>
                        <template v-else>
                            <fa-icon v-if="titleIcon" :icon="titleIcon" />
                        </template>
                        <span class="modal-card-title-wrap">
                            <span v-text="title" />
                            <span
                                v-if="titleIconTooltip"
                                v-tooltip.right="{
                                    content: titleIconTooltip.text,
                                    triggers: [],
                                    shown: hoverIcon,
                                    container: '.modal-card-title-icon',
                                    boundary: '.modal-card-head',
                                    html: true,
                                }"
                                class="modal-card-title-icon"
                                @mouseover="mouseoverIcon($event)"
                                @mouseout="mouseoutIcon($event)"
                            >
                                <fa-icon :icon="titleIconTooltip.icon" />
                            </span>
                        </span>
                    </p>
                    <a
                        v-if="!hideCloseIcon"
                        class="delete"
                        :class="{ 'is-disabled': form && form.busy }"
                        @click="closeModal('icon')"
                    />
                </header>
                <progress-bar
                    v-if="showProgressBar"
                    :value="progressBarValue"
                    :max="100"
                    :size="'is-small'"
                    :type="'is-primary'"
                />
                <section
                    class="modal-card-body"
                    :class="{
                        'modal-card-body-disable-overflow': disableOverflow,
                    }"
                >
                    <slot>No modal content provided.</slot>
                </section>
                <footer v-if="!hideFoot" class="modal-card-foot" :class="footerClasses">
                    <template v-if="$slots.footer">
                        <slot name="footer" />
                    </template>
                    <template v-else-if="customOrder">
                        <slot name="cancel">
                            <a
                                v-if="!hideCancel"
                                class="button button--cancel"
                                :class="[compiledCancelClasses, { 'is-disabled': isCloseDisabled || busy || (form && form.busy) || (formOther && formOther.busy) }]"
                                :style="{
                                    marginRight: actionLeft ? 'auto' : '10px',
                                }"
                                @click="closeModal('button')"
                            >
                                {{ cancelText }}
                            </a>
                        </slot>

                        <a
                            v-if="!hideAction"
                            class="button button--action"
                            :class="[compiledActionClasses, { 'is-disabled': busy || (form && form.busy) || (formOther && formOther.busy) }]"
                            :style="{
                                marginRight: actionLeft || !hideBack ? 'auto' : '10px',
                            }"
                            @click="actionModal"
                        >
                            {{ actionText }}
                        </a>

                        <slot name="action">
                            <button
                                v-if="!hideSubmit"
                                class="button button--submit"
                                :type="useClickButton ? 'button' : 'submit'"
                                :class="compiledSubmitClasses"
                                :disabled="
                                    submitDisabled ||
                                        busy ||
                                        (form && form.busy) ||
                                        (formOther && formOther.busy)
                                "
                                @click="click"
                            >
                                {{ submitText }}
                            </button>
                        </slot>
                    </template>
                    <template v-else>
                        <a
                            v-if="!hideAction"
                            class="button button--action"
                            :class="[compiledActionClasses, { 'is-disabled': busy || (form && form.busy) || (formOther && formOther.busy) }]"
                            :style="{
                                marginRight: actionLeft || !hideBack ? 'auto' : '10px',
                            }"
                            @click="actionModal"
                        >
                            {{ actionText }}
                        </a>

                        <slot name="back">
                            <button
                                v-if="!hideBack"
                                class="button button--back"
                                :class="compiledBackClasses"
                                type="button"
                                :style="{
                                    marginRight: actionLeft ? 'auto' : '10px',
                                }"
                                :disabled="
                                    backDisabled ||
                                        busy ||
                                        (form && form.busy) ||
                                        (formOther && formOther.busy)
                                "
                                @click="backModal"
                            >
                                <fa-icon v-if="backIcon" :icon="backIcon" />
                                <span>
                                    {{ backText }}
                                </span>
                            </button>
                        </slot>

                        <slot name="cancel">
                            <a
                                v-if="!hideCancel"
                                class="button button--cancel"
                                :class="[compiledCancelClasses, { 'is-disabled': isCloseDisabled || busy || (form && form.busy) || (formOther && formOther.busy) }]"
                                :style="{
                                    marginRight: actionLeft ? 'auto' : '10px',
                                }"
                                @click="closeModal('button')"
                            >
                                {{ cancelText }}
                            </a>
                        </slot>

                        <slot name="action">
                            <button
                                v-if="!hideSubmit"
                                class="button button--submit"
                                :type="useClickButton ? 'button' : 'submit'"
                                :class="compiledSubmitClasses"
                                :disabled="
                                    submitDisabled ||
                                        busy ||
                                        (form && form.busy) ||
                                        (formOther && formOther.busy)
                                "
                                @click="click"
                            >
                                {{ submitText }}
                            </button>
                        </slot>
                    </template>
                </footer>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: { type: String, default: '' },
        form: { type: Object, default: null },
        formOther: { type: Object, default: null },
        confirm: { type: Boolean, default: false },
        size: { type: String, default: '' },
        title: { type: String, default: 'No Modal Title' },
        titleIcon: { type: [String, Boolean, Array], default: '' },
        titleIconTooltip: { type: [String, Boolean, Array, Object], default: false },
        titleChange: { type: Function, default: null },
        submitClasses: { type: [Array, String, Object], default: null },
        footClasses: { type: [Array, String, Object], default: null },
        submitText: { type: String, default: 'Submit' },
        submitDisabled: { type: Boolean, default: false },
        hideSubmit: { type: Boolean, default: false },
        cancelClasses: { type: [Array, String, Object], default: null },
        cancelText: { type: String, default: 'Cancel' },
        hideCancel: { type: Boolean, default: false },
        backIcon: { type: [String, Array], default: '' },
        backText: { type: String, default: 'Back' },
        backDisabled: { type: Boolean, default: false },
        backClasses: { type: [Array, String, Object], default: null },
        hideBack: { type: Boolean, default: true },
        hideAction: { type: Boolean, default: true },
        actionText: { type: String, default: 'Action' },
        actionLeft: { type: Boolean, default: false },
        actionClasses: { type: [Array, String, Object], default: null },
        successHtml: { type: [String, null], default: null },
        successText: { type: String, default: 'Success!' },
        closeOnSuccess: { type: Boolean, default: true },
        hideHeader: { type: Boolean, default: false },
        hideFoot: { type: Boolean, default: false },
        showError: { type: Boolean, default: false },
        errorText: { type: String, default: '' },
        disableOverflow: { type: Boolean, default: false },
        busy: { type: Boolean, default: false },
        isSuccessful: { type: Boolean, default: false },
        isCloseBackground: { type: Boolean, default: false },
        isCloseDisabled: { type: Boolean, default: false },
        useClickButton: { type: Boolean, default: false },
        showProgressBar: { type: Boolean, default: false },
        progressBarValue: { type: Number, default: null },
        hideCloseIcon: { type: Boolean, default: false },
        preventClose: { type: Boolean, default: false },
        cardClass: { type: [String, Object], default: null },
        width: { type: [Number, null], default: null },
        customOrder: { type: Boolean, default: false },
    },

    emits: ['submit', 'closed', 'action', 'back', 'opened'],

    data() {
        return {
            active: false,
            closeTimeout: null,
            hoverIcon: false,
        };
    },

    computed: {
        /**
         * Returns all of the classes for the modal.
         *
         * @returns Array
         */
        classes() {
            let classes = [
                this.size,
                this.confirm ? 'is-confirm' : '',
                this.hideFoot ? 'is-footless' : '',
            ];

            if (this.showError) {
                classes.push('is-error');
            }

            if (this.form && this.form.successful) {
                classes.push('is-successful');
            } else if (!this.showError) {
                classes.push(this.type);
            }

            if (this.disableOverflow) {
                classes.push('modal-disable-overflow');
            }

            return classes;
        },

        cardStyles() {
            const styles = {};

            if (this.width) {
                styles.width = `${this.width}px`;
            }

            return styles;
        },

        /**
         * Returns the classes for the cancel button.
         *
         * @return {*}
         */
        compiledCancelClasses() {
            if (this.cancelClasses) {
                return this.cancelClasses;
            } else {
                return {
                    'is-fullwidth': this.hideSubmit,
                };
            }
        },

        /**
         * Returns the classes for the submit button.
         *
         * @return {*}
         */
        compiledSubmitClasses() {
            if (this.submitClasses) {
                return this.submitClasses;
            } else {
                let classes = {
                    'is-busy':
                        this.busy ||
                        (this.form && this.form.busy) ||
                        (this.formOther && this.formOther.busy),
                    'is-fullwidth': this.hideCancel && this.hideBack,
                };

                classes[this.type] = true;

                return classes;
            }
        },

        /**
         * Returns the classes for the action button.
         *
         * @return {*}
         */
        compiledActionClasses() {
            return this.actionClasses;
        },

        /**
         * Returns the classes for the back button.
         *
         * @return {*}
         */
        compiledBackClasses() {
            return this.backClasses;
        },

        footerClasses() {
            if (this.footClasses) {
                return this.footClasses;
            }

            return {};
        },
    },

    watch: {
        /**
         * Watches the successful state and automatically closes the modal.
         *
         * @param {Boolean} val
         * @return {void}
         */
        'form.successful'(val) {
            if (val && this.closeOnSuccess) {
                this.closeTimeout = setTimeout(() => {
                    this.closeModal();
                }, 1500);
            } else {
                clearTimeout(this.closeTimeout);
            }
        },
    },

    methods: {
        actionModal() {
            if (this.busy || (this.form && this.form.busy) || (this.formOther && this.formOther.busy)) return;
            this.$emit('action');
        },

        backModal() {
            if (this.backDisabled || this.busy || (this.form && this.form.busy) || (this.formOther && this.formOther.busy)) return;
            this.$emit('back');
        },
        /**
         * Closes the modal.
         *
         * @return {void}
         */
        closeModal(type) {
            if (this.isCloseDisabled || this.busy || (this.form && this.form.busy) || (this.formOther && this.formOther.busy)) return;
            if (type === 'background' && !this.isSuccessful && !this.isCloseBackground) return;

            if (!this.preventClose) {
                this.active = false;
            }

            setTimeout(() => {
                this.$emit('closed', type);
            }, 201);
        },

        /**
         * Handles the modal submit procedure.
         *
         * @return {void}
         */
        submit() {
            if (this.useClickButton) return;

            this.$emit('submit');
        },

        click() {
            if (!this.useClickButton) return;

            this.$emit('submit');
        },

        mouseoverIcon(e) {
            this.hoverIcon = true;
        },

        mouseoutIcon(e) {
            this.hoverIcon = false;
        },
    },

    mounted() {
        setTimeout(() => {
            this.active = true;
            this.$emit('opened');
        }, 10);
    },
};
</script>
